import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TViewSwitcherKey, TLongTermOptionValue } from '@models/home';
import { Button, Select } from 'antd';

import './ViewSwitcher.scss';

interface IViewSwitcherProps {
  onViewSwitch: (key: TViewSwitcherKey) => void;
  onLongTermOptionChange: (option: TLongTermOptionValue) => void;
}

function ViewSwitcher({
  onViewSwitch,
  onLongTermOptionChange,
}: IViewSwitcherProps) {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState<TViewSwitcherKey>('immediate');
  const [activeLongTermOption, setActiveLongTermOption] =
    useState<TLongTermOptionValue>('MONTH');

  const longTermOptions: { label: string; value: TLongTermOptionValue }[] = [
    {
      label: t('ViewSwitcher.ThisMonth'),
      value: 'MONTH',
    },
    {
      label: t('ViewSwitcher.ThisQuarter'),
      value: 'QUARTER',
    },
    {
      label: t('ViewSwitcher.ThisYear'),
      value: 'YEAR',
    },
    {
      label: t('ViewSwitcher.All'),
      value: 'ALL',
    },
  ];

  useEffect(() => onViewSwitch(activeKey), [activeKey]);
  useEffect(
    () => onLongTermOptionChange(activeLongTermOption),
    [activeLongTermOption],
  );

  return (
    <div className="ViewSwitcher">
      <Button
        type={activeKey === 'immediate' ? 'primary' : 'text'}
        className={`ViewSwitcher__button ${
          activeKey === 'immediate' ? 'ViewSwitcher__button--active' : ''
        }`}
        onClick={() => {
          setActiveKey('immediate');
        }}
      >
        {t('ViewSwitcher.RealTimeInfo')}
      </Button>
      <Button
        type={activeKey === 'longTerm' ? 'primary' : 'text'}
        className={`ViewSwitcher__button ViewSwitcher__button--longTerm ${
          activeKey === 'longTerm' ? 'ViewSwitcher__button--active' : ''
        }`}
        onClick={() => {
          setActiveKey('longTerm');
        }}
      >
        {t('ViewSwitcher.LongTermInfo')}
        <Select
          disabled={activeKey !== 'longTerm'}
          options={longTermOptions}
          onChange={(value) => {
            setActiveLongTermOption(value);
          }}
          value={activeLongTermOption}
          placeholder={t('ViewSwitcher.SelectInterval')}
          className="ViewSwitcher__select"
        />
      </Button>
    </div>
  );
}

export default ViewSwitcher;
